import { createI18n } from "vue-i18n";

import en from "./en.json";

// There are 2 default languages:
// English and "none" which means it shows the i18n keys instead of the translations.
// This can be helpful to quickly correct a translation error.
// To quickly switch language, one can use the `lang` URL query parameter.

const DEFAULT_LOCALE = "en";
const FALLBACK_LOCALE = "en";

const none = Object.fromEntries(Object.entries(en).map(([key]) => [key, key]));

export const i18n = createI18n({
  legacy: false,
  allowComposition: true,
  locale: DEFAULT_LOCALE,
  fallbackLocale: FALLBACK_LOCALE,
  messages: { en, none },
  fallbackWarn: false,
  missingWarn: false,
});

// cast is wrong, but seems to be no clean solution for dynamically loaded languages
export function setLocale(locale: string) {
  i18n.global.locale.value = locale as typeof i18n.global.locale.value;
}

export function useGlobalI18n() {
  return {
    t: i18n.global.t,
    tt: (params: [key: string, params?: Record<string, unknown>]) =>
      i18n.global.t(params[0], params[1] ?? {}),
  };
}
